import { BaseService } from 'core/services';
import EmailTemplatesRouteService from './EmailTemplatesRouteService';

class EmailTemplatesService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new EmailTemplatesRouteService());
    }

    updateBody(id, resource) {
		const url = this.routeService.update(id, resource);
		return this.apiClient.put(url, resource);
	}
}

export default EmailTemplatesService;
